/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const LabSwitcherSvg = () => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 64 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M50,22v-4C50,8.1,41.9,0,32,0S14,8.1,14,18v4c0,7.7-6.3,14-14,14h64c-7.7,0-14-6.3-14-14Z"/>
  </svg>
);

export const LabSwitcherMask = props => <Icon component={LabSwitcherSvg} {...props} />;
